module.exports = __webpack_public_path__ + "static/media/facebook.72acab8e.svg";